import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Tabs from '../../common/Tabs';
import ScreenBusySpinner from '../../common/ScreenBusySpinner';
import Paper, { PaperHeader, PaperHeaderNav } from '../../common/layout/Paper';
import { AppDispatch, RootState } from '../../../data/store';
import { fetchCompany } from '../../../data/thunks/companyThunk';
import CompanyProjectTypes from '../../company/CompanyProjectTypes';
import CompanyProjectFolders from '../../company/CompanyProjectFolders';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import CompanyProjectData from '../../company/CompanyProjectData';

export default function DEPRECATED_ProjectSettingsScreen() {
	const location = useLocation();
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(fetchCompany());
	}, [dispatch]);

	const {
		company: { projectTypes, projectFolders, initialized },
	} = useSelector((state: RootState) => state.companyState);

	const basePath = '/projects/settings';
	const panels = [
		{
			label: 'Project Types',
			component: (
				<CompanyProjectTypes
					projectTypes={projectTypes}
					initialized={initialized}
				/>
			),
			href: `${basePath}/types`,
			key: `${basePath}/types`,
		},
		{
			label: 'Project Folders',
			component: (
				<CompanyProjectFolders
					projectFolders={projectFolders}
					initialized={initialized}
				/>
			),
			href: `${basePath}/folders`,
			key: `${basePath}/folders`,
		},
		{
			label: 'Project Data',
			component: <CompanyProjectData />,
			href: `${basePath}/data`,
			key: `${basePath}/data`,
		},
	];

	return (
		<>
			<PageWrapper>
				<Container gradientBorder>
					<BoxContainer>
						{' '}
						<PaperHeader>
							<PaperHeaderNav
								onClick={() => navigate('/projects')}
							>
								Projects <ChevronRightOutlinedIcon />
							</PaperHeaderNav>
							<Namespace>Project Settings</Namespace>
						</PaperHeader>
						<Tabs panels={panels} currentPath={location.pathname} />
					</BoxContainer>
				</Container>
			</PageWrapper>
		</>
	);
}

const PageWrapper = styled.div`
	display: flex;
	width: 100%;
	height: calc(100vh - 95px); /* Adjust based on actual top nav bar height */
	position: relative;
`;

const Container = styled(Paper)`
	flex: 1;
	width: 100%;
	margin-right: 0;
	display: flex;
	flex-direction: column; /* Stack header/tabs and content vertically */
	overflow: hidden; /* Prevent Container itself from scrolling */
	background-color: ${({ theme }) => theme.palette.background.paper};
	border-radius: 8px; /* Match MUI Box default */
`;

const Namespace = styled.div`
	display: inline;
	color: ${({ theme }) => theme.palette.text.primary};
`;

const BoxContainer = styled(Box)`
	padding: 12px 13px 0 13px;
	width: 100%;
`;
